<template>
  <v-container>
    <login-form />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import LoginForm from "../components/LoginForm.vue";

export default {
  name: "Login",
  components: { LoginForm },
  computed: { ...mapGetters(["getUsers"]) },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
